import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
// Footer style
classname = "ct-footer footer-dark";
ftlogo = "assets/img1/logo.png"
  constructor() { }

  ngOnInit(): void {
  }

}
